const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
    <style>
        button {
          font-family: "Lato", sans-serif;
        }
        h1 {
            color: #000000;
            font-size: 24px;
            font-weight: 700;
            margin: 0;
            margin-left: 20px;
        }
        .horizontal-border-grey {
            border: none;
            height: 1px;
            color: #ECECEC;
            background-color: #ECECEC;
            margin: 12px 0 24px 20px;
        }
        .btn-group{
            float: right;
            margin: 9px 0 60px 0;
          }

        .btn-group button {
          background-color: #3570D2;
          color: white;
          cursor: pointer;
          margin-left: 12px;
          border-radius: 5px;
          border: none;
          width: 160px;
          height: 44px;
        }
      
        .btn-group:after {
          content: "";
          clear: both;
          display: table;
        }

        .content-empty {
          text-align: center;
        }

        .content-empty h2 {
          font-size: 18px;
          font-weight: 700;
          color: #424242;
          margin: 0;
          margin-top: 100px;
          line-height: 24px;
        }

        .content-empty p {
          font-weight: 400;
          font-size: 16px;
          color: #7F7F7F;
          margin: 0
          line-height: 24px;
          top: 38px;
        }
    </style>
</template>`
styleElement.register("webinar-landing-list-style");